"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentService = void 0;
const app_1 = require("app");
class ComponentService {
    constructor() {
        this.components = [];
        this.pendingUpdateComponent = [];
        $(() => {
            app_1.PageService.Init();
            this.InitComponents();
            app_1.PageService.AttachOnBodyClickHandlers();
            app_1.PageService.AttachOnWindowResizeHandlers();
            app_1.PageService.AttachOnWindowResizeThrottleHandlers();
            app_1.PageService.AttachOnPopStateHandlers();
            app_1.PageService.AttachOnScrollThrottleHandler();
            app_1.PageService.AttachOnHashChangeHandler();
            app_1.PageService.AttachOnPageLoadHandler();
            app_1.PageService.AttachOnTouchStartHandler();
            app_1.PageService.AttachOnTouchEndHandler();
        });
    }
    AddComponent(component) {
        this.components.push(component);
    }
    AddPendingUpdateComponent(component) {
        if (this.pendingUpdateComponent.indexOf(component) === -1) {
            this.pendingUpdateComponent.push(component);
        }
    }
    UpdateComponentsSelector() {
        this.pendingUpdateComponent.forEach(component => {
            if (component.selector) {
                component.el = document.querySelectorAll(component.selector);
                if (component.el.length > 0) {
                    component.OnInstancesUpdated();
                }
            }
        });
        this.pendingUpdateComponent = [];
    }
    componentProperties(component) {
        component.OnBodyClick &&
            app_1.PageService.AddOnBodyClickHandler(component.OnBodyClick.bind(component));
        component.OnWindowResize &&
            app_1.PageService.AddOnWindowResizeHandler(component.OnWindowResize.bind(component));
        component.OnWindowResizeThrottle &&
            app_1.PageService.AddOnWindowResizeThrottleHandler(component.OnWindowResizeThrottle.bind(component));
        component.OnPopStateHandler &&
            app_1.PageService.AddOnPopStateHandler(component.OnPopStateHandler.bind(component));
        component.OnScrollThrottle &&
            app_1.PageService.AddOnScrollThrottleHandler(component.OnScrollThrottle.bind(component));
        component.OnHashChange &&
            app_1.PageService.AddOnHashChangeHandler(component.OnHashChange.bind(component));
        component.OnPageLoad && app_1.PageService.AddOnPageLoadHandler(component.OnPageLoad.bind(component));
        component.OnTouchStart &&
            app_1.PageService.AddOnTouchStartHandler(component.OnTouchStart.bind(component));
        component.OnTouchEnd && app_1.PageService.AddOnTouchEndHandler(component.OnTouchEnd.bind(component));
    }
    InitComponents() {
        this.components.forEach(component => {
            if (component.selector) {
                component.el = document.querySelectorAll(component.selector);
                if (!component.el.length && component.skipInitIfNotOnPage) {
                    return;
                }
            }
            try {
                component.BeforeInit && component.BeforeInit();
                component.OnInit && component.OnInit();
            }
            catch (_a) {
                component.componentHasError = true;
            }
            if (!component.componentHasError) {
                this.componentProperties(component);
            }
        });
    }
}
const service = new ComponentService();
exports.ComponentService = service;
